/**
 * Policies that should continue using OLD safety score event
 * (policy_safety_score_changed) instead of the new one.
 *
 * All policies NOT in this list will only accept the NEW event
 * (policy_new_safety_score_changed).
 */
export const SAFETY_SCORE_EXCEPTION_POLICIES: ReadonlyArray<string> = [
  // Rebates excluded policies
  `571c0c30-0c03-47ee-8f43-00ae6a5deb2c`, // Storage Centre Wailes - ADMFL-000155
  `1f3e65a8-69e4-4d6d-a886-5b010d2b7667`, // H20 Logistics Ltd - ADMFL-000115
  // Ram API excluded policies
  `0273bb06-c5a6-49b9-bf7d-404a258d532c`, // Fisk Group Hire Limited - ADMFL-000326
  `034ec8cd-4185-474d-89a6-4308b4e44d18`, // Ocean Cabs (Anglia) Ltd - HAVFL-000191
  `0c4ecb67-d35d-4b8a-b6a9-903867e73db1`, // JJD Logistics Ltd - ADMFL-000098
  `24ef0109-d52d-4c07-b093-fdbdca70a208`, // Stewarts Medical Couriers Ltd - ADMFL-000244
  `30e069e8-17ac-4000-a94b-3be55be076d3`, // FA-Ibi Ltd - HAVFL-000139
  `88cf111f-7e50-4085-9fe7-43cf38846bce`, // Fisk Fire Protection Limited t/a Fisk Group - ADMFL-000327
  `90139271-c3ae-4b4b-8ca9-e84e6a709c6a`, // Adrian Marshall t/as Beckford Contract Services - ADMFL-000164
  `9931dce0-4890-43f8-a944-c764385b1a99`, // DAT Transport Services Ltd - ADMFL-000192
  `ae00c7bd-d924-4b61-862b-00ebd2333c15`, // Mansfield Van Hire Ltd - ADMFL-000335
  `b029145e-6356-407e-a549-de799bcab5c5`, // Ayrshire Vehicle Rental Ltd - ADMFL-000160
  `b4cbe7f9-c5c8-4660-a2a6-831795d5004b`, // Peacock Express Distribution Ltd - ADMFL-000116
  `b5efdc0e-8ce5-4369-b7d4-e5cedaec85c0`, // Richards Light Haulage Ltd - ADMFL-000240
  `b8240032-802b-49f5-8a2a-a017c573c19d`, // SA4 Logistics Ltd - ADMFL-000350
  `bfea3e13-4e3c-45dc-9750-96fe0e0a401c`, // Orange Vehicle Rental Ltd - ADMFL-000305
  `cfb466be-3c86-4edc-86b5-440d7083584c`, // RKM Transports Ltd - ADMFL-000200
  `d090efdd-3781-480b-bb55-30486eb3e929`, // JCS Storage & Hire Ltd - ADMFL-000201
  `e72ba015-a586-4af7-8c28-efb01b9c491a`, // Cameron's Couriers Ltd & Martin Cameron - ADMFL-000220
]

/**
 * Checks if a policy should use the OLD safety score event
 * @param policyId - The policy UUID or string to check
 * @returns true if policy should use OLD event, false if should use NEW event
 */
export const isNewPipelinePolicy = (policyId: string): boolean =>
  !SAFETY_SCORE_EXCEPTION_POLICIES.includes(policyId) && process.env.APP_ENV === `prod`
